import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppStaticPageRoutingModule } from './app-static-page-routing.module';
import { HelpCenterComponent } from './help-center/help-center.component';


@NgModule({
  declarations: [
    HelpCenterComponent
  ],
  imports: [
    CommonModule,
    AppStaticPageRoutingModule
  ]
})
export class AppStaticPageModule { }
